import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import classes from './VerbalScore.module.css';
import selectArrowIcon from '../../../../../assests/assessments/select-arrow.png';
import useClickOutside from "../../../../../hooks/useClickOutside";
import { onKeyDown } from "../../../../../service";

const VerbalScoreSelect = ({ c, criterionIndex, changeSelectedAppreciationTextOption }) => {

    const { texts, lang } = useSelector(state => state.translate);

    const [showSelect, setShowSelect] = useState(false);

    const selectRef = useRef(null);

    const handleSelect = (value) => {
        changeSelectedAppreciationTextOption(value, criterionIndex)
        setShowSelect(false);
    }

    useClickOutside(selectRef, () =>
        setShowSelect(false)
    );

    const handleChangeSelect = e => {
        e.stopPropagation();
        setShowSelect(showSelect => !showSelect);
    }

    return (
        <div className={classes.SelectContainer}>
            <div className={classes.SelectWrapper}>
                <div className={classes.SelectSelected} onClick={handleChangeSelect} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, handleChangeSelect)}>
                    <div className={` ${!c.selectedAppreciationTextOption && classes.PlaceHolder} `}>{c.selectedAppreciationTextOption ? c.appreciationOptionForVerbal[c.selectedAppreciationTextOption]?.text[lang] : texts.choiceAssessment}</div>
                    <img src={selectArrowIcon} alt="SelectArrow" className={showSelect ? classes.SelectArrowIconOpen : classes.SelectArrowIconClose} />
                </div>
                {showSelect && !c.disable && <div ref={selectRef} className={classes.SelectDropDown}>
                    {Object.keys(c.appreciationOptionForVerbal).map((val, index) =>
                        <div
                            key={index}
                            className={`${classes.Option} ${c.selectedAppreciationTextOption == val ? classes.SelectedOption : ''}`}
                            onClick={() => handleSelect(val)}
                            tabIndex="0"
                            role="button"
                            onKeyDown={e => onKeyDown(e, () => handleSelect(val))}>
                            {c.appreciationOptionForVerbal[val]?.text[lang]}
                        </div>
                    )}
                </div>}
            </div>
        </div>
    )
}

export default VerbalScoreSelect;